import type { DreadBand, SoloRunState, StateBucket, Track } from './types.js';

export function dreadBand(dread: number): DreadBand {
  if (dread <= 3) return 'low';
  if (dread <= 6) return 'mid';
  return 'high';
}

export function dominantTrack(tracks: Record<Track, number>): Track {
  const entries = Object.entries(tracks) as [Track, number][];
  entries.sort((a, b) => b[1] - a[1]);
  return entries[0]?.[0] ?? 'hope';
}

export function computeStateBucket(state: Pick<SoloRunState, 'tracks' | 'dread'>): StateBucket {
  const dominant = dominantTrack(state.tracks);
  const band = dreadBand(state.dread);
  const stateKey = `${dominant}_${band}`;
  return { dominantTrack: dominant, dreadBand: band, stateKey };
}

export function buildOutcomeKey(
  storyId: string,
  beatId: string,
  cardId: string,
  stateKey: string,
): string {
  return `${storyId}/${beatId}/${cardId}/${stateKey}`;
}
